import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavigationTile from 'components/shared/NavigationTile';

import type { PhotoUpload } from 'domains/photos';

type CollectionPhotoTileProps = {
  photo: PhotoUpload;
  onDelete: () => void;
  onMove: () => void;
  onSelect: () => void;
};

function CollectionPhotoTile(props: CollectionPhotoTileProps) {
  const { photo, onDelete, onMove, onSelect } = props;

  const menuItems = [
    {
      label: 'Load',
      icon: <FontAwesomeIcon icon="film" />,
      click: onSelect,
    },
    {
      label: (
        <span>
          Delete <span className="screen-reader-text">{photo.original_filename}</span>
        </span>
      ),
      id: `delete-collection-photo-${photo.id}`,
      icon: <FontAwesomeIcon icon="trash-alt" />,
      click: onDelete,
    },
    {
      label: 'Move to...',
      icon: <FontAwesomeIcon icon="image" />,
      click: onMove,
    },
  ];

  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('text/plain', JSON.stringify(photo));
  };

  return (
    <li draggable="true" onDragStart={handleDragStart}>
      <NavigationTile
        item={photo}
        className={'image'}
        draggable
        image={photo.file_path_thumb}
        name={photo.original_filename}
        clickHandler={onSelect}
        menuItems={menuItems}
      />
    </li>
  );
}

export default CollectionPhotoTile;
